import { yupResolver } from '@hookform/resolvers/yup'
import React, { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import tw from 'twin.macro'
import * as yup from 'yup'

import WarningIcon from '../assets/icons/WarningIcon'
import { Button } from '../components/UI/button/button'
import { MaskedInput } from '../components/UI/input/masked-input'
import { useCardActivationMutation } from '../redux/api/mega-card-activation.api'
import { cardQuantitySelector } from '../redux/store/slices/mega-card-activation-slice'

function IDNenterPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [sendIDN, { isLoading }] = useCardActivationMutation()
  const cardQuantity = useSelector(cardQuantitySelector)
  const schema = useMemo(
    () =>
      yup.object({
        idn: yup
          .string()
          .min(9, t('validation', { ns: 'idn' }) as string)
          .max(12)
      }),
    [t]
  )
  const {
    control,
    formState: { errors, isValid },
    setError,
    getValues
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { idn: '' }
  })

  const handleSendIDN = async () => {
    try {
      const idn = getValues().idn
      if (idn) {
        await sendIDN({ idn: idn }).unwrap()
        navigate('/activation-loading')
      }
    } catch (error) {
      const typedError = error as {
        data: {
          error: { description: { idn: string[] }; code: string }
        }
      }
      setError('idn', { type: 'idn', message: typedError.data.error.description.idn[0] })
    }
  }

  return (
    <div tw='w-full flex justify-center items-center mt-5 sm:mt-0'>
      <div tw='w-[500px] rounded-s20 bg-secondary p-10 flex flex-col gap-5 items-center'>
        <h2 tw='text-s18 font-bold'>{t('activation-new-card', { ns: 'idn' })}</h2>
        {cardQuantity && (
          <span tw='text-secondary text-sm self-start flex gap-2 items-center'>
            <WarningIcon />
            {t('availability-count', { count: cardQuantity as number, ns: 'idn' })}
          </span>
        )}
        <MaskedInput
          mask={'999999999999'}
          control={control}
          isValid={isValid}
          name={'idn'}
          label={t(`idn-of-card`, { ns: 'idn' })}
          placeholder={t('placeholder', { ns: 'idn' })}
          error={errors.idn?.message}
        />
        <Button disabled={!isValid} onClick={handleSendIDN} loading={isLoading} variant='gradient'>
          {t('continue', { ns: 'idn' })}
        </Button>
      </div>
    </div>
  )
}

export default IDNenterPage
